import React from 'react';
import PropTypes from 'prop-types';

import { Section } from '../Section';
import { RadioWrapper, Radio } from './styles';

export const SpendCalculationSection = ({
	useNetSpend,
	animationIndex,
	onChange,
}) => {
	return (
		<Section title="Spend calculation options" animationIndex={animationIndex}>
			<RadioWrapper>
				<Radio
					name="useNetSpend"
					defaultChecked={!useNetSpend}
					onChange={_0 =>
						onChange({ useNetSpend: false, tailSpendHasChanged: true })
					}
				>
					Use only positive spend
				</Radio>
				<Radio
					name="useNetSpend"
					defaultChecked={!!useNetSpend}
					onChange={_0 =>
						onChange({ useNetSpend: true, tailSpendHasChanged: true })
					}
				>
					Use net spend
				</Radio>
			</RadioWrapper>
		</Section>
	);
};

SpendCalculationSection.propTypes = {
	useNetSpend: PropTypes.bool.isRequired,
	animationIndex: PropTypes.number.isRequired,
	onChange: PropTypes.func.isRequired,
};
